import { useMemo } from 'react'

import { usePermission } from '@circlefin/permissions/react'
import { TabNavigation } from '@containers/layout'
import { BILLING_PROFILE_SECTION } from '@services/permissions'
import {
  autoPaySection,
  billingProfileSection,
  feeHistorySection,
  invoicesSection,
  paymentMethodsSection,
} from '@services/sections/lib/billing'

export const BillingTabNav: React.FC = () => {
  const [, { isAuthorized: billingProfileEnabled }] = usePermission(
    BILLING_PROFILE_SECTION,
  )

  const tabs = useMemo(
    () => [
      invoicesSection,
      feeHistorySection,
      paymentMethodsSection,
      autoPaySection,
      ...(billingProfileEnabled ? [billingProfileSection] : []),
    ],
    [billingProfileEnabled],
  )

  return <TabNavigation routes={tabs} variant="underlined-black" />
}
